<div class="container page-content">
    <form class="example-form" [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
     
      <div class="form-group">
        <label class="form-label">Client Name</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [value]="clientName" disabled /> 
        </mat-form-field>
      </div>
      <div class="form-group">
        <label class="form-label">Company Name</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [value]="companyName" disabled />
        </mat-form-field>
      </div>
      <div *ngFor="let control of templateDetails" class="form-group">
        <label [for]="control.columnName" class="form-label">{{ control.columnDisplayName }}</label>
         <mat-form-field appearance="outline" class="full-width"> 
          <ng-container *ngIf="isDropdown(control.columnName); else otherInputs">
            <mat-select *ngIf="control.columnName === 'paidCurrency'" [formControlName]="control.columnName" [id]="control.columnName">
              <mat-option *ngFor="let currency of currencies" [value]="currency.bocmCurrencyID">
                {{ currency.currencyCode }}
              </mat-option>
            </mat-select>
          </ng-container>
          <ng-template #otherInputs>
            
             <ng-container *ngIf="isDatePicker(control.columnName); else textInput">
              <div class="mat-form-field-wrapper">
                <input matInput [max]="today" [matDatepicker]="picker" [formControlName]="control.columnName" [id]="control.columnName"   />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker> 
              </div>
             </ng-container> 
            
            <ng-template #textInput>
              <input matInput [formControlName]="control.columnName" [id]="control.columnName" />
            
            </ng-template>
          </ng-template> 
          
          <mat-error *ngIf="paymentForm.get(control.columnName)?.hasError('required')">
            {{ control.columnDisplayName }} is <strong>required</strong>
          </mat-error>
        </mat-form-field> 
      </div>
      <div class="form-group" style="text-align: center;">
        <button mat-raised-button type="submit" [disabled]="paymentForm.invalid" class="btn btn-primary">
          Submit
        </button>
      </div>
      <br>
    </form>
    <div *ngIf="isLoading" class="fullscreen-spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>